// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__19ylO","title":"Images90_title__33i51","images":"Images90_images__2618R"};